/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { toast } from "react-toastify";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";
import {
  filedForceApproval,
  filedForceDeniedAccount,
  getSpecificFieldForceAccount,
  resetEditFieldForceAccount,
} from "../../../../../redux/features/accounts/fieldForceAccount";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import globalText from "../../../../../utils/globalText";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";

const FieldForceAccountEditContactSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const updatedFields = location?.state?.updatedFields || [];

  const {
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountError,
  } = useSelector((state) => state.fieldForceAccount);
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [actionLoading, setActionLoading] = useState("");
  const isActionLoading = actionLoading !== "";
  const [isFocused, setIsFocused] = useState(false);
  const fieldForceAccount =
    getSpecificFieldForceAccountData?.field_force_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ];

  const services = useSelector((state) => state.refreshToken.services);

  const getSuccessTitle = () => {
    return "Account details updated successfully.";
  };

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const viewDetailsHandler = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard");
  };

  const showActionError = (response, fallbackText) => {
    toast.dismiss();
    CommonToast({
      text:
        response?.payload?.errors?.field_force_account?.[
          GlobalConfiguration.lengthCheckZero
        ] ||
        response?.payload?.errors?.base?.[
          GlobalConfiguration.lengthCheckZero
        ] ||
        fallbackText,
      variant: "var(--error)",
      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
      buttonNeeded: false,
    });
  };

  const accountApproval = async () => {
    setActionLoading("approve");
    toast.dismiss();
    UniversalRefreshToast("Approving account");
    try {
      const response = await dispatch(filedForceApproval(id));
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Account approved successfully.",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
        });
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
        );
      } else {
        showActionError(response, "An error occurred while approving account.");
      }
    } catch {
      showActionError(null, "An error occurred while approving account.");
    } finally {
      setActionLoading("");
    }
  };

  const accountRejected = async (reason) => {
    setActionLoading("reject");
    setRejectPopup(false);
    toast.dismiss();
    UniversalRefreshToast("Rejecting account");
    try {
      const response = await dispatch(
        filedForceDeniedAccount({ id, AccountIdData: reason }),
      );
      if (response?.payload?.status) {
        toast.dismiss();
        CommonToast({
          text: "Account rejected successfully.",
          variant: "var(--success)",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          buttonNeeded: false,
        });
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
        );
      } else {
        showActionError(response, "An error occurred while rejecting account.");
      }
    } catch {
      showActionError(null, "An error occurred while rejecting account.");
    } finally {
      setActionLoading("");
    }
  };

  const fieldsToShow = updatedFields.length
    ? updatedFields
    : [
        "account_name",
        "contact_no",
        "email_id",
        "linked_user",
        "transaction_limit",
      ];

  const fieldConfig = {
    account_name: {
      leftSubTitle: "Account name",
      getTitle: (acc) => acc?.name || "Not available",
    },
    contact_no: {
      leftSubTitle: "Contact number",
      icon: ICONS?.CONTACT_WITH_WHITE_CIRCLE,
      getTitle: (acc) =>
        acc?.contact_no ? `+91 ${acc.contact_no}` : "Not available",
      iconSize: "small",
      bgNeeded: false,
    },
    email_id: {
      leftSubTitle: "Email ID",
      leftTitleColor: "var(--pending)",
      icon: ICONS?.CONTACT_US_MAIL,
      getTitle: (acc) => acc?.email_id || "Not available",
      iconSize: "small",
      bgNeeded: false,
      hasLink: true,
    },
    linked_user: {
      leftSubTitle: "Linked user",
      getTitle: (acc) => acc?.field_force_user_full_name || "Not linked",
    },
    transaction_limit: {
      leftSubTitle: "Transaction limit",
      getTitle: (acc) =>
        acc?.field_force_custom_limit != null
          ? `INR ${acc.field_force_custom_limit}`
          : "Not available",
    },
  };

  const renderInfoCards = () =>
    fieldsToShow
      .filter((key) => fieldConfig[key])
      .map((key) => {
        const config = fieldConfig[key];
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: config.getTitle(fieldForceAccount),
                leftSubTitle: config.leftSubTitle,
                leftTitleColor: config.leftTitleColor,
                hasLink: config.hasLink,
                ...(config.icon && { icon: config.icon }),
                ...(config.iconSize && {
                  iconSize: config.iconSize,
                }),
                ...(config.bgNeeded === false && { bgNeeded: false }),
              },
            ]}
          />
        );
      });

  const buttonRows = [
    ...(services?.includes("FFAAccount") ||
    (services?.includes("Admin") &&
      fieldForceAccount?.approval_status === "pending")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                if (isActionLoading) return;
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
              isDisabled: actionLoading === "approve",
              isLoaderNeeded: true,
              isLoading: actionLoading === "reject",
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                if (isActionLoading) return;
                accountApproval();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
              isDisabled: actionLoading === "reject",
              isLoaderNeeded: true,
              isLoading: actionLoading === "approve",
            },
          ],
        ]
      : []),
    [
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: () => {
          if (isActionLoading) return;
          viewDetailsHandler();
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
        isDisabled: isActionLoading,
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: () => {
          if (isActionLoading) return;
          dashboardHandler();
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
        isDisabled: isActionLoading,
      },
    ],
  ];
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;
    if (length === 0) return "default";
    if (length >= GlobalConfiguration.rejectReasonMinLength) return "verified";
    return focused ? "typing" : "error";
  };

  const handleInputChange = (event) => {
    const sanitizedValue = event.target.value
      .replace(/\s+/g, " ")
      .replace(/^\s/, "")
      .slice(0, 150);

    setDeclineReason(sanitizedValue);
  };

  useEffect(() => {
    dispatch(getSpecificFieldForceAccount({ id }));
    dispatch(resetEditFieldForceAccount());
  }, [dispatch, id]);

  useEffect(() => {
    if (getSpecificFieldForceAccountError) {
      navigate("*");
    }
  }, [getSpecificFieldForceAccountError]);

  return (
    <>
      <div>
        {rejectPopup && (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
            <SmallPopupWithInput
              headerTitle="Reject account"
              subtext="Provide the reason for rejection."
              headerFontColor="text-primary"
              headerFontWeight="semibold"
              textSize="font-md"
              inputBgColor="var(--primary-bg)"
              inputFgColor="var(--text-secondary)"
              inputOnInput={(e) => {
                handleInputChange(e);
              }}
              noteText={globalText?.REJECT_POPUP_ACCOUNT_NOTE_TEXT}
              noteColor="text-secondary"
              bulletPoints={[
                "New requests and transactions cannot be created for this account.",
                "Before rejecting this account, reject all associated transactions and requests.",
                "Users can edit the rejected account to update details.",
              ]}
              inputValue={declineReason}
              inputPlaceholder={"Reason"}
              inputOnFocus={() => setIsFocused(true)}
              inputOnBlur={() => setIsFocused(false)}
              inputVariant={computeVariant(declineReason, isFocused)}
              inputFontKind="medium"
              inputIsFullWidth={true}
              btnOneHandleFunction={() => {
                setRejectPopup(false);
                setDeclineReason("");
              }}
              btnOneText="Cancel"
              btnOneBtnType="button"
              btnOneEnabledBgColor="trans"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={
                !declineReason ||
                declineReason.length < GlobalConfiguration.panLength
              }
              btnOneIsDisabled={isActionLoading}
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoHoverOption="black"
              btnTwoText="Reject"
              btnTwoHandleFunction={() => {
                accountRejected(declineReason);
                setDeclineReason("");
              }}
              btnTwoBtnType="submit"
              btnTwoInActiveVariantNeeded={true}
            />
          </div>
        )}
        <StatusContainer
          status="success"
          hoverOption="white"
          buttonRows={buttonRows}
          title={getSuccessTitle()}
        >
          <TabsWeapperSection title="Updated details">
            <>{renderInfoCards()}</>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default FieldForceAccountEditContactSuccess;
